// extracted by mini-css-extract-plugin
export default {"container":"Setting_container__C6IwI","change_password_box":"Setting_change_password_box__vyaKV"};